export const observerOptions = {
  threshold: 0,
};
